import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "settings-account-info" */ './index')
);
